import React, { lazy, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Route, Switch } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { withRouter } from 'react-router';

import { getHostWithProtocol } from 'utils/getHostWithProtocol';
import { ROUTES } from '../constants';

const Auth = lazy(() => import('pages/Auth'));
const Landing = lazy(() => import('pages/Landing'));
const MockInterviews = lazy(() => import('pages/MockInterviews'));
const Interview = lazy(() => import('pages/Interview'));
const MockInterviewTest = lazy(() =>
  import('pages/MockInterviewPlayBackTests')
);
const Interview_AI = lazy(() => import('pages/InterviewAI'));
const InterviewPreBuilt = lazy(() => import('pages/InterviewPreBuilt'));
const InterviewCustom = lazy(() => import('pages/InterviewCustom'));
const MockInterviewPreStart = lazy(() => import('pages/MockInterview'));
const Questions = lazy(() => import('pages/Questions'));
const QuestionsCustomInterview = lazy(() =>
  import('pages/QuestionsCustomInterview')
);
const InterviewsList = lazy(() => import('pages/InterviewsList'));
const Feedback = lazy(() => import('pages/MockFeedback'));
const MockInterviewRecording = lazy(() =>
  import('pages/MockInterviewRecording')
);
const MockInterviewEnd = lazy(() => import('pages/MockInterviewEnd'));
const ReviewGrid = lazy(() => import('pages/ReviewGrid'));
const ShareInterview = lazy(() => import('pages/ShareInterview'));
const Recruiter = lazy(() => import('pages/Recruiter'));
const InterviewRecruiter = lazy(() => import('pages/InterviewRecruiter'));
const NotFound = lazy(() => import('pages/NotFound'));

const AppRouter = ({ location }) => {
  const {
    referringUserId,
    mobileApp,
    mobileAppName,
    encryptedUserId,
    externalAccessId,
  } = useSelector((state) => state.auth);
  const hostUrl = getHostWithProtocol();

  return (
    <Switch>
      <Route exact path="/" component={Auth} />
      <Route path={`/${ROUTES.LANDING}/:tag?`} component={Landing} />
      <Route path={`/${ROUTES.INTERVIEW}/:id/:session`} component={Interview} />
      <Route path={`/${ROUTES.INTERVIEW}/:id`} component={Interview} />
      <Route path={`/${ROUTES.INTERVIEW_AI}/:id`} component={Interview_AI} />
      <Route
        path={`/${ROUTES.INTERVIEW_PRE_BUILT}`}
        component={InterviewPreBuilt}
      />
      <Route path={`/${ROUTES.INTERVIEW_CUSTOM}`} component={InterviewCustom} />
      <Route
        path={`/${ROUTES.MOCK_INTERVIEWS}/:tag?`}
        component={MockInterviews}
      />
      <Route
        path={`/${ROUTES.MOCK_INTERVIEW_TEST}/:id`}
        component={MockInterviewTest}
      />
      <Route
        path={`/${ROUTES.MOCK_INTERVIEW_START}/:id`}
        component={MockInterviewPreStart}
      />
      <Route
        path={`/${ROUTES.MOCK_INTERVIEW_RECORD}/:id/:question`}
        component={MockInterviewRecording}
      />
      <Route
        path={`/${ROUTES.MOCK_INTERVIEW_END}/:id/:question`}
        component={MockInterviewEnd}
      />
      <Route path={`/${ROUTES.QUESTIONS}/:tag?`} component={Questions} />
      <Route
        path={`/${ROUTES.QUESTIONS_CUSTOM_INTERVIEW}`}
        component={QuestionsCustomInterview}
      />
      <Route path={`/${ROUTES.INTERVIEWS_LIST}`} component={InterviewsList} />
      <Route path={`/${ROUTES.FEEDBACK}/:id/:session`} component={Feedback} />
      <Route path={`/${ROUTES.REVIEW_GRID}`} component={ReviewGrid} />
      <Route path={`/${ROUTES.SHARE_INTERVIEW}`} component={ShareInterview} />
      <Route path={`/${ROUTES.RECRUITER}`} component={Recruiter} />
      <Route
        path={`/${ROUTES.INTERVIEW_RECRUITER}/:id`}
        component={InterviewRecruiter}
      />
      <Route component={NotFound} />
    </Switch>
  );
};

AppRouter.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }),
};

export default withRouter(AppRouter);
